export var ReducerType;
(function (ReducerType) {
    ReducerType["Account"] = "account";
    ReducerType["Alerts"] = "alerts";
    ReducerType["Allergens"] = "allergens";
    ReducerType["Announcements"] = "announcements";
    ReducerType["Checkout"] = "checkout";
    ReducerType["CommunicationPrefs"] = "communicationPreferences";
    ReducerType["Config"] = "config";
    ReducerType["Confirmation"] = "confirmation";
    ReducerType["CompletedOrders"] = "completedOrders";
    ReducerType["CreditCards"] = "creditCards";
    ReducerType["Customer"] = "customer";
    ReducerType["CustomerAddresses"] = "addresses";
    ReducerType["CustomerAllergens"] = "allergens";
    ReducerType["Deals"] = "deals";
    ReducerType["Donations"] = "donations";
    ReducerType["Favorites"] = "favorites";
    ReducerType["FcmToken"] = "fcmToken";
    ReducerType["Geolocation"] = "geolocation";
    ReducerType["GiftCards"] = "giftCards";
    ReducerType["GroupOrder"] = "groupOrder";
    ReducerType["GroupOrders"] = "groupOrders";
    ReducerType["Guest"] = "guest";
    ReducerType["History"] = "history";
    ReducerType["HouseAccounts"] = "houseAccounts";
    ReducerType["Loader"] = "loader";
    ReducerType["Loyalty"] = "loyalty";
    ReducerType["Menu"] = "menu";
    ReducerType["MenuDisplay"] = "menuDisplay";
    ReducerType["MenuItems"] = "menuItems";
    ReducerType["Misc"] = "misc";
    ReducerType["Modal"] = "modal";
    ReducerType["Nav"] = "nav";
    ReducerType["NavSite"] = "navSite";
    ReducerType["Notifications"] = "notifications";
    ReducerType["OneTimePasscode"] = "oneTimePasscode";
    ReducerType["Order"] = "order";
    ReducerType["OrderFulfillment"] = "orderFulfillment";
    ReducerType["OrderRating"] = "orderRating";
    ReducerType["Orders"] = "orders";
    ReducerType["Posts"] = "posts";
    ReducerType["PointsShop"] = "pointsShop";
    ReducerType["PushNotifications"] = "pushNotifications";
    ReducerType["Qr"] = "qr";
    ReducerType["QRCode"] = "qrcode";
    ReducerType["Quote"] = "quote";
    ReducerType["ResetPassword"] = "resetPassword";
    ReducerType["RevenueCenters"] = "revenueCenters";
    ReducerType["Rewards"] = "rewards";
    ReducerType["RewardCode"] = "rewardCode";
    ReducerType["Settings"] = "settings";
    ReducerType["Sidebar"] = "sidebar";
    ReducerType["SidebarModal"] = "sidebarModal";
    ReducerType["SignUp"] = "signUp";
    ReducerType["Tags"] = "tags";
    ReducerType["Terms"] = "terms";
    ReducerType["Thanx"] = "thanx";
    ReducerType["Tpls"] = "tpls";
    ReducerType["TplsPointsShop"] = "tplsPointsShop";
    ReducerType["Unsubscribe"] = "Unsubscribe";
    ReducerType["ValidTimes"] = "validTimes";
    ReducerType["VerifyAccount"] = "verifyAccount";
})(ReducerType || (ReducerType = {}));
